import Colors from 'theme/colors';

export const card: any = {
  backgroundColor: Colors.WHITE,
  borderRadius: 12,
  padding: 16,
  marginBottom: 16,
  boxShadow: '0 1px 4px rgba(0,0,0,0.08)',
};

export const label: any = {
  display: 'block',
  fontSize: 13,
  fontWeight: 700,
  marginBottom: 8,
  color: Colors.TEXT,
};

export const hint: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#555',
  margin: '0 0 12px',
};

export const privacy: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#1b5e20',
  background: '#e8f5e9',
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 16,
};

export const warnBox: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#e65100',
  background: '#fff3e0',
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 12,
};

export const errorBox: any = {
  fontSize: 13,
  lineHeight: 1.5,
  color: '#b71c1c',
  background: '#ffebee',
  borderRadius: 8,
  padding: '10px 12px',
  marginBottom: 12,
};

export const btnRow: any = {
  display: 'flex',
  flexWrap: 'wrap' as const,
  gap: 8,
  marginBottom: 12,
};

const btnBase: any = {
  border: 'none',
  borderRadius: 8,
  padding: '12px 14px',
  fontSize: 15,
  fontWeight: 700,
  cursor: 'pointer',
  minHeight: 44,
};

export const primaryBtn: any = {
  ...btnBase,
  backgroundColor: Colors.MAIN_COLOR,
  color: Colors.WHITE,
};

export const secondaryBtn: any = {
  ...btnBase,
  backgroundColor: '#eceff1',
  color: Colors.TEXT,
};

export const dangerBtn: any = {
  ...btnBase,
  backgroundColor: '#ffebee',
  color: '#c62828',
};

/** Full-width primary action on narrow screens — merge with primaryBtn. */
export const touchBtnFull: any = {
  width: '100%',
  boxSizing: 'border-box',
};

export const textArea: any = {
  width: '100%',
  boxSizing: 'border-box',
  padding: 12,
  borderRadius: 8,
  border: `1px solid ${Colors.CARD_BORDER}`,
  fontSize: 16,
  fontFamily: 'inherit',
  resize: 'vertical' as const,
  minHeight: 88,
  lineHeight: 1.45,
};

export const dropZone: any = {
  border: '2px dashed #b0bec5',
  borderRadius: 10,
  padding: '20px 14px',
  textAlign: 'center' as const,
  background: '#fafafa',
  cursor: 'pointer',
  marginBottom: 8,
  userSelect: 'none' as const,
};

export const dropZoneActive: any = {
  ...dropZone,
  borderColor: Colors.MAIN_COLOR,
  background: '#e3f2fd',
};

export const chipScrollRow: any = {
  display: 'flex',
  flexWrap: 'nowrap' as const,
  gap: 8,
  marginBottom: 12,
  overflowX: 'auto' as const,
  WebkitOverflowScrolling: 'touch',
  paddingBottom: 4,
};

export function formatMb(bytes: number): string {
  return (bytes / (1024 * 1024)).toFixed(1);
}

export function chipStyle(active: boolean): any {
  return {
    ...secondaryBtn,
    backgroundColor: active ? Colors.MAIN_COLOR : '#eceff1',
    color: active ? Colors.WHITE : Colors.TEXT,
    whiteSpace: 'nowrap' as const,
    flexShrink: 0,
  };
}

export function btnDisabled(style: any): any {
  return {
    ...style,
    opacity: 0.55,
    cursor: 'not-allowed',
  };
}
